"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOPIC_CONCEPT_STATUS_STATS_FRAGMENT = exports.TOPIC_VIDEO_STATUS_STATS_FRAGMENT = exports.TOPIC_FIELDS = void 0;
const client_1 = require("@apollo/client");
exports.TOPIC_FIELDS = (0, client_1.gql) `
  fragment TopicFields on Topic {
    id
    name
    demo
    typeId
    entitlement {
      id
      name
    }
    totalQuestions
    correctQuestions
    incorrectQuestions
    totalCards
    greenCards
    yellowCards
    redCards
    dailyFeedCards
  }
`;
// used in cache updator
exports.TOPIC_VIDEO_STATUS_STATS_FRAGMENT = (0, client_1.gql) `
  fragment TopicVideoStatusStats on Topic {
    unwatchedVideos
    completedVideos
    revisingVideos
    urgentVideos
  }
`;
// used in cache updator
exports.TOPIC_CONCEPT_STATUS_STATS_FRAGMENT = (0, client_1.gql) `
  fragment TopicConceptStatusStats on Topic {
    unreadConcepts
    completedConcepts
    revisingConcepts
    urgentConcepts
  }
`;
